import { createStore, applyMiddleware, combineReducers } from 'redux';
import { thunk } from 'redux-thunk';
import userReducer from './reducers/userReducer';
import loaderReducer from './reducers/loaderReducer';
import notificationReducer from './reducers/notificationReducer';
import planReducer from './reducers/planReducer';


// Combine reducers if you have multiple reducers
const rootReducer = combineReducers({
    user: userReducer, // Add the user reducer to the root reducer
    loader: loaderReducer,
    notification: notificationReducer,
    plan: planReducer,
  
    // Add other reducers here if needed
  });

const store = createStore(rootReducer, applyMiddleware(thunk));

export default store;
